/* SeoProse — renders supporting educational/SEO copy below interactive tools.
   Reads section objects from the content source of truth (PAGES[route].sections):
   { h, paragraphs?[], bullets?[] }. Visual style matches the rest of the site;
   this is content/structure only — no redesign. */
const SeoProse = ({ sections = [], className = "" }) => {
  if (!sections.length) return null;
  return (
    <section className={`max-w-3xl ${className}`} data-testid="seo-prose">
      {sections.map((s) => (
        <div key={s.h} className="mt-10">
          <h2 className="font-sora text-2xl font-semibold tracking-tight text-[#0B1220]">{s.h}</h2>
          {s.paragraphs?.map((p) => (
            <p key={p.slice(0, 40)} className="mt-3 text-[#475569] leading-relaxed">{p}</p>
          ))}
          {s.bullets && (
            <ul className="mt-4 space-y-2.5">
              {s.bullets.map((b) => (
                <li key={b.slice(0, 40)} className="flex gap-3 text-[15px] text-[#475569] leading-relaxed">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#10B981] shrink-0" aria-hidden="true" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </section>
  );
};

export default SeoProse;
